var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25519 0.710938H0V5.47284L35.7217 29.2824L40 29.2824V24.5205L4.25519 0.710938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41924 0.710938L40 26.4927V29.2824L38.614 29.2824L0 3.47391V0.710938H1.41924Z",
    fill: "#F93939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1905 0.710938H40V5.47284C40 5.47284 15.2568 21.3358 3.80952 29.2824H0V24.5205L36.1905 0.710938Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0.710938H38.7081L0 26.5149V29.2824H1.41924L40 3.49477V0.710938Z",
    fill: "#F93939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5468 0.710938H25.4865V9.52392H40V20.4636H25.4865V29.2824H14.5468V20.4636H0V9.52392H14.5468V0.710938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8421 0.710938H23.1579V11.6999H40V18.2934H23.1579V29.2824H16.8421V18.2934H0V11.6999H16.8421V0.710938Z",
    fill: "#F93939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "assets/20250410153110/media/uk.08ed8815c08e3d400435266c0176c1ef.svg";
export { ForwardRef as ReactComponent };